import DeleteClientContainer from "./DeleteClientContainer";
export default DeleteClientContainer;
